<template>
    <div
	v-if="$store.state.show"
	class="search-bg">
		<div class="search-box">
			<div class="search">
				<div class="search-title">
					<h1>查数字经济企业，上网经社企业库</h1>
				</div>
				
			    <!-- <el-autocomplete
			    class="inline-input"
			    v-model="keywords"
			    :fetch-suggestions="querySearch"
			    placeholder="请输入企业名称"
			    :trigger-on-focus="false"
			    @select="handleSelect"
			    prefix-icon="el-icon-search"></el-autocomplete> -->
				<el-input
				v-if="ifres"
				class="input-with-select"
				:placeholder="placeholder"
				v-model="keywords"
				@keyup.enter.native="getSearch()"
				@input="inputSearch">
					<el-select
					class="search-select"
					v-model="type"
					slot="prepend"
					@change="chooseType">
						<el-option label="平台" value="平台"></el-option>
						<el-option label="省份" value="省份"></el-option>
						<el-option label="城市" value="城市"></el-option>
					</el-select>
							
					<el-button
					type="primary"
					plain
					slot="append"
					icon="el-icon-search"
					@click="getSearch()"></el-button>
				</el-input>
			
				<el-input
				v-else
				class="input-with-select"
				placeholder="请输入企业名称"
				v-model="keywords"
				@keyup.enter.native="handleSelect()"
				>
					<el-button
					type="primary"
					plain
					slot="append"
					icon="el-icon-search"
					@click="handleSelect()"></el-button>
				</el-input>
			</div>
		</div>
	</div>
</template>

<script>
export default {
    name: 'Search',
	props:{
		ifres:false
	},
    data() {
        return {
            type: '平台',
            keywords: '',
			placeholder: '如：淘宝、京东、拼多多'
        }
    },
    methods: {
        chooseType(val) {
            this.type = val
			switch(val) {
				case '平台':
					this.placeholder = '如：淘宝、京东、拼多多'
					break;
				case '省份':
					this.placeholder = '如：广东、浙江、江苏'
					break;
				case '城市':
					this.placeholder = '如：北京、上海、杭州'
					break;
			}
            this.keywords = ''
            this.$store.commit('modifyParameter')
        },
        getSearch() {
			switch(this.type) {
				case '省份':
					if(!this.keywords.includes('省')) {
						this.keywords += '省'
					}else if('北京上海深圳天津重庆'.includes(this.keywords.slice(0, 2))) {
						this.keywords += '市'
					}
					break;
				case '城市':
					if(!this.keywords.includes('市')) {
						this.keywords += '市'
					}
					break;
			}

            this.$store.commit('modifyParameter', {
                type: this.type,
                key: this.keywords
            })

            this.$store.dispatch('getAxios', this.$store.state.parameter)
            this.$store.commit('getPage', 1)

            // if(this.keywords == '') {
            //     this.$message({
            //         showClose: true,
            //         message: '请键入搜索关键词',
            //         type: 'error',
            //     })
            // }
			
        },
		handleSelect() {
			if(this.type == '平台') {
			    window.open('/enterprise/#/Inside?name=' + this.keywords)
			}
			//  else if(this.type != '平台') {
			// 	window.open('/enterprise/#/list?field=全部&category=全部')
			// }
		},
        inputSearch() {
            if(this.keywords == '') {
                this.$store.commit('modifyParameter')
                this.$store.dispatch('getAxios', this.$store.state.parameter)
                this.$store.commit('getPage', 1)

            }
        }
        // errOpen() {
        //     message({
        //         showClose: true,
        //         message: '未找到相关数据，请输入其他平台名！',
        //         type: 'error',
        //     })
        // }
    },
}
</script>

<style scoped>
.search-bg {
	width: 100%;
	background: linear-gradient(90deg, #409eff, #6780f8);
	margin-top: 62px;
}
.search-box {
	display: flex;
	justify-content: center;
	align-items: center;
	max-width: 1200px;
	height: 260px;
	margin: auto;
}
.search {
    display: flex;
	flex-wrap: wrap;
	justify-content: center;
    width: 72%;
    margin: auto;
}
.search-title {
	flex: 0 0 100%;
	text-align: center;
	margin-bottom: 20px;
}
.search-title h1 {
	font-size: 24px;
	color: #fff;
	letter-spacing: 5px;
	line-height: 0;
}
.search .el-input-group {
    width: 64%;
    margin: auto;
}
.search-select {
	color: #409eff;
	background: #ecf5ff;
	border-color: #b3d8ff;
}

@media(max-width: 868px) {
	.search-bg {
		margin-top: 0;
	}
	
	.search-box {
		height: 200px
	}
	
	.search {
		width: 90%;
	}
	
    .search .el-input-group {
        width: 100%;
    }
	
	.search-title h1 {
		font-size: 18px;
		letter-spacing: 0;
	}
}
</style>